import React from "react";
import { AlertTriangle, TrendingDown } from "lucide-react";

const LiveTaxImpact = ({ regime }) => {
  return (
    <div className="space-y-6">
      {/* Declaration Window Alert */}
      <div className="bg-red-50 border border-red-100 rounded-lg p-4 flex gap-3">
        <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0" />
        <div>
          <h4 className="text-sm font-semibold text-red-700">Declaration window closes<br/>31 Jan</h4>
        </div>
      </div>

      {/* Tax Impact Card */}
      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
        <h2 className="text-lg font-semibold mb-1">Live Tax Impact</h2>
        <p className="text-xs text-gray-500 mb-6">Based on your current declarations</p>
        
        <div className="space-y-3 mb-6">
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Gross Salary</span>
            <span className="font-medium">₹14,00,000</span>
          </div>
          
          {regime === "old" ? (
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">HRA exemption</span>
              <span className="font-medium">₹1,50,000</span>
            </div>
          ) : (
            <>
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Standard deduction</span>
                <span className="font-medium">₹75,000</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Deduction allowed</span>
                <span className="font-medium text-gray-400">None</span>
              </div>
            </>
          )}

          <div className="flex justify-between text-sm pt-2 border-t border-gray-100">
            <span className="text-gray-500">Taxable income ({regime})</span>
            <span className="font-medium">{regime === "old" ? "₹12,25,000" : "₹13,25,000"}</span>
          </div>
          
          <div className="flex justify-between text-sm mt-4">
            <span className="text-gray-500">Tax — old regime</span>
            <span className="font-medium">₹1,67,200</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">Tax — new regime</span>
            <span className="font-medium">₹1,30,000</span>
          </div>
        </div>

        {/* Suggestion Box */}
        {regime === "old" ? (
          <div className="bg-green-50 border border-green-100 rounded-lg p-4">
            <div className="flex items-start gap-2">
              <TrendingDown className="w-4 h-4 text-green-600 mt-0.5" />
              <div>
                <h4 className="text-sm font-semibold text-green-800">Old regime is currently cheaper by ₹13,600.</h4>
                <p className="text-xs text-green-700 mt-1">
                  You can still switch to the new regime while filing your return.
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="bg-green-50 border border-green-100 rounded-lg p-4">
            <div className="flex items-center gap-2">
              <TrendingDown className="w-4 h-4 text-green-600" />
              <h4 className="text-sm font-semibold text-green-800">New regime is currently cheaper.</h4>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveTaxImpact;
